import React from "react";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import config from 'config';
import i18n from "I18n";

import ImageUploader from "components/base/ImageUploader";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import { LanguageConfig } from "config/CustomEnums";
import { errorMessage } from "components/base/ErrorFieldMessage";

import { insertKeyToAllLanguages } from "utils";
import ReactHookFormSwitch from "components/reactHookFormComponents/ReactHookFormSwitch";

const PhotoUploaderWithSwitch = ({
  languages,
  language,
  wordTranslationVariable={},
  withTranslation = true,
  title = "",
  tips = "",
  focusChange,
  uploaderAspect,
  maxImageNum = 1,
  tranlationFieldPrefix = "translations",
  photoFieldName = "",
  activeSectionKey = photoFieldName,
  switchConfig = {
    fieldName: "",
    title: "",
  },
  ...otherProps
}) => {
  const { formState: { errors }, watch, setValue, getValues, } = useFormContext();
  const applyToAllLanguagesFieldName = switchConfig?.fieldName || "";
  const watchApplyToAllLangauge = watch(applyToAllLanguagesFieldName) || false;
  // eslint-disable-next-line no-unused-vars
  const translation = withTranslation ? watch(tranlationFieldPrefix) : {}

  const wholePhotoField = withTranslation ? `${tranlationFieldPrefix}.${language}.${photoFieldName}` : photoFieldName;
  const defaultPhoto = maxImageNum > 1 ? []: ""
  const watchPhoto = watch(wholePhotoField) || defaultPhoto;

  const uploadedPhotoList = maxImageNum > 1 ? watchPhoto || [] : [watchPhoto || ""]?.filter((item) => item);
  return <>
    {title && <CustomTitleLabel title={withTranslation ? i18n.t(title, { locale: language, ...wordTranslationVariable }) : title} />}
    {tips && <label className="tips-message">
      {withTranslation ? i18n.t(tips, { locale: language, ...wordTranslationVariable }) : tips}
    </label>}

    <ImageUploader
      minWidth={900}
      minHeight={config.campaignRectangleSize.minHeight}
      disabled={
        language !== LanguageConfig.english && watchApplyToAllLangauge
      }
      images={uploadedPhotoList}
      onImageStateChange={(newState) => {
        if (withTranslation) {
          const applyLanguages = watchApplyToAllLangauge
            ? languages
            : [language];
          insertKeyToAllLanguages({
            languages: applyLanguages,
            key: photoFieldName,
            value: maxImageNum > 1 ? newState : newState[0],
            setValue,
            getValues,
          });
        } else {
          setValue(wholePhotoField, maxImageNum > 1 ? newState : newState?.[0], { shouldDirty: true });
        }
      }}
      aspect={uploaderAspect}
      maxImageNum={maxImageNum}
      uploadImageClicked={() => focusChange(activeSectionKey)}
      language={language}
      errorMessage={errorMessage(
        errors,
        wholePhotoField,
      )}
      {...otherProps}
    />
    <span id={wholePhotoField} />
    {applyToAllLanguagesFieldName && language === LanguageConfig.english &&
      <ReactHookFormSwitch
        title={switchConfig?.title || ""}
        valueFieldName={applyToAllLanguagesFieldName}
        extraActionOnChange={(value) => {
          if (value) {
            insertKeyToAllLanguages({
              languages,
              key: photoFieldName,
              value: watch(wholePhotoField),
              setValue,
              getValues,
            });
          }
        }}
      />
    }
  </>
}
const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

export default connect(mapPropsToState)(PhotoUploaderWithSwitch);